import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations.ts';

i18n.use(initReactI18next).init({
  resources: translations,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  nsSeparator: false,
  keySeparator: '|',
});

export default i18n;
